import { Post } from "../../../../types";
import { AlertTriangle, UserCheck, XOctagon } from "react-feather";
import { useState } from "react";
import { useAuth } from "../../../../global-components/src";
import { User } from "../../../../global-components/src/types";
import { t } from "i18next";

interface PostProps{
    user?: User;
    isWarned?: boolean;
}

const WarnUserDropdown: React.FC<PostProps> = ({ user, isWarned }) => {
    const { isAuthenticated } = useAuth();

    return (
        <>
        {isAuthenticated && user?.can_send_warn && !isWarned ? (
            <>
                <li>
                    <span className="dropdown-item cursor-pointer user-select-none">
                        <div data-bs-toggle="modal" data-bs-target="#warn-user" className="div-icon-fix"> 
                            <XOctagon data-feather="paperclip" data-type="unfix" className="icon-config-post"/>{t("post.actions.sendWarning")}
                        </div> 
                    </span>
                </li>
            </>
        ) : null}
        
        </>
    );
};

export default WarnUserDropdown;
